import React, { useRef } from 'react';
import styled from 'styled-components';

import useServicesImport from 'core/hooks/useServicesImport';
import LoadingButton from 'Elements/Form/LoadingButton';

const HiddenInput = styled.input`
  display: none;
`;

export default function ServiceImportButton() {
  const { importServices, loading } = useServicesImport();
  const ref = useRef<HTMLInputElement>(null);

  const selectFile = () => ref.current && ref.current.click();

  const handleChange: React.FormEventHandler<HTMLInputElement> = (event) => {
    if (event.currentTarget.files != null) {
      importServices(event.currentTarget.files[0]);
    }
  };

  return (
    <>
      <LoadingButton
        variant="contained"
        color="secondary"
        onClick={selectFile}
        loading={loading}
      >
        Vie työ- & tarvikelista
      </LoadingButton>

      <HiddenInput type="file" ref={ref} onChange={handleChange} />
    </>
  );
}
